/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { exportIntegrationIndex } from '../../axios/exportIntegrationIndex'
import type {
	ExportIntegrationIndexError,
	ExportIntegrationIndexQueryParams,
	ExportIntegrationIndexResponse,
} from '../../types/ExportIntegrationIndex'

export const exportIntegrationIndexQueryKey = (params?: ExportIntegrationIndexQueryParams) =>
	[{ url: '/export-integrations' }, ...(params ? [params] : [])] as const

export type ExportIntegrationIndexQueryKey = ReturnType<typeof exportIntegrationIndexQueryKey>

/** @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportIntegrationController.php ExportIntegrationController::index */
export function exportIntegrationIndexQueryOptions(
	params?: ExportIntegrationIndexQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		ExportIntegrationIndexResponse,
		AxiosError<ExportIntegrationIndexError>,
		ExportIntegrationIndexResponse,
		ExportIntegrationIndexQueryKey
	>({
		queryKey: exportIntegrationIndexQueryKey(params),
		queryFn: ({ signal }) => exportIntegrationIndex(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportIntegrationController.php ExportIntegrationController::index */
export function useExportIntegrationIndex<TSelectData = ExportIntegrationIndexResponse>(
	params?: ExportIntegrationIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					ExportIntegrationIndexResponse,
					AxiosError<ExportIntegrationIndexError>,
					TSelectData,
					ExportIntegrationIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<ExportIntegrationIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...exportIntegrationIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportIntegrationController.php ExportIntegrationController::index */
export function useExportIntegrationIndexSuspense<TSelectData = ExportIntegrationIndexResponse>(
	params?: ExportIntegrationIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					ExportIntegrationIndexResponse,
					AxiosError<ExportIntegrationIndexError>,
					TSelectData,
					ExportIntegrationIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<ExportIntegrationIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...exportIntegrationIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
